import {$http} from '@/utils/https'
import {STUDENTS_SET_ALL_LIST, STUDENTS_SET_LIST, SYUDENTS_REQUEST_STATUS} from './types/mutation-types';

import {FETCH_STUDENTS_LIST} from './types/action-types';


const state = {
    listStudents: [],
    isListStudentsLoading: false,
    listAllStudents: []
};

const getters = {
    listStudents: state => state.listStudents,
    isListStudentsLoading: state => state.isListStudentsLoading,
    listAllStudents: state => state.listAllStudents,
};

const actions = {
    [FETCH_STUDENTS_LIST]: async ({commit}, payload) => {
        try {
            if (payload?.limit) {
                commit(SYUDENTS_REQUEST_STATUS, true);

                const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.id}/widgets/best-students?limit=${payload.limit}`);

                commit(STUDENTS_SET_LIST, response.data.data);
                return response;
            } else {
                commit(SYUDENTS_REQUEST_STATUS, true);

                const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.id}/widgets/best-students`);

                commit(STUDENTS_SET_ALL_LIST, response.data.data);
                return response;
            }

        } catch (e) {
            throw e;
        } finally {
            commit(SYUDENTS_REQUEST_STATUS, false);
        }
    },
};

const mutations = {
    [STUDENTS_SET_LIST](state, list) {
        state.listStudents = list;
    },
    [STUDENTS_SET_ALL_LIST](state, list) {
        state.listAllStudents = list;
    },
    [SYUDENTS_REQUEST_STATUS](state, status) {
        state.isListStudentsLoading = status;
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
};
